//@ts-nocheck
import {Injectable} from '@angular/core';
import * as _ from 'lodash';
import {KEYCLOAK_INIT} from '../../ngrx/common/module-initialization.actions';
import {Store} from '@ngrx/store';

@Injectable({
    providedIn: 'root'
})
export class KeycloakService {
    private readonly PROXY_HOSTNAMES: Array<string> = ['apps2.outfit7.com', 'apps2-hk.outfit7.com'];
    private readonly DEFAULT_KEYCLOAK_URL: string = 'https://accounts-be.outfit7.net/auth/';
    private readonly PROXY_KEYCLOAK_URL: string = 'https://accounts-be2.outfit7.net/auth/';
    private readonly REALM: string = 'backend';
    private readonly CLIENT_ID: string = 'VISUAL7';

    private readonly keycloak: Keycloak;

    private resolveAuthenticated: (isAuthenticated: boolean) => void;
    private isAuthenticatedPromise: Promise<boolean> = new Promise<boolean>(resolve => {
        this.resolveAuthenticated = resolve;
    });

    private constructor(private store: Store) {
        this.keycloak = new Keycloak({
            url: this.resolveKeycloakServerUrl(),
            realm: this.REALM,
            clientId: this.CLIENT_ID,
        });
    }

  private getRealmRoles(): string[] {
    return _.defaultTo(this.keycloak?.tokenParsed?.realm_access?.roles, []);
  }

    private getResourceRoles(): string[] {
      if (!this.keycloak?.tokenParsed?.resource_access) {
        return [];
      }

      const allRoles: string[] = [];
      const resources: string[] = _.keys(this.keycloak.tokenParsed.resource_access) || [];
      for (const resource of resources) {
        const roles: string[] = this.keycloak.tokenParsed.resource_access[resource]?.roles || [];
        allRoles.push(...roles);
      }

      return allRoles;
    }

    public async setupAuthentication(): Promise<void> {
        await this.keycloak
            .init({
                onLoad: 'login-required',
                checkLoginIframe: false,
                pkceMethod: 'S256',
                redirectUri: window.location.href,
            })
            .then((authenticated: boolean) => {
                if (authenticated) {
                    this.store.dispatch({type: KEYCLOAK_INIT});
                    this.resolveAuthenticated(true);
                }
                // Set token refresh interval
                setInterval(() => {
                    this.keycloak
                        .updateToken(70)
                        .catch((error: Error) => {
                            console.error('Failed to refresh token', error);
                        });
                }, 6000);
            })
            .catch((error: Error) => {
                console.error(error);
                this.resolveAuthenticated(false);
            });
    }

    public isAuthenticated(): Promise<boolean> {
        return this.isAuthenticatedPromise;
    }

    public getKeycloakInstance(): Keycloak {
        return this.keycloak;
    }

    public getUserRoles(): string[] {
      const realmRoles: string[] = this.getRealmRoles();
      const resourceRoles: string[] = this.getResourceRoles();

      return [...realmRoles, ...resourceRoles];
    }

    public getUsername(): string {
        return this.keycloak?.tokenParsed?.preferred_username;
    }

    public async logout(): Promise<void> {
        await this.getKeycloakInstance().logout();
    }

    private resolveKeycloakServerUrl(): string {
        const isOnReverseProxy: boolean = window.location != undefined && this.PROXY_HOSTNAMES.indexOf(window.location.hostname) != -1;
        return isOnReverseProxy ? this.PROXY_KEYCLOAK_URL : this.DEFAULT_KEYCLOAK_URL;
    }
}
